import { CommonModule } from '@angular/common';
import {
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
} from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'doc-carousel',
  standalone: true,
  imports: [CommonModule, NgbCarouselModule],
  template: `
    <ngb-carousel
      class="doc-carousel-panel carousel slide"
      [ngClass]="styleClass"
      [interval]="effectiveInterval"
      [wrap]="circular"
      [keyboard]="true"
      [pauseOnHover]="pauseOnHover"
      [showNavigationArrows]="showNavigators"
      [showNavigationIndicators]="showIndicators">
      @for (slide of value ?? []; track trackSlide($index, slide)) {
        <ng-template ngbSlide>
          @if (itemTemplate) {
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: slide, index: $index }">
            </ng-container>
          }
        </ng-template>
      }
    </ngb-carousel>
  `,
  styleUrl: './doc-carousel.component.scss',
})
export class DocCarouselComponent {
  /** PrimeNG-compatible alias for slide items. */
  @Input() value: unknown[] | null = [];

  /** Kept for PrimeNG API compatibility (single-slide view only). */
  @Input() numVisible = 1;

  /** Kept for PrimeNG API compatibility. */
  @Input() numScroll = 1;

  @Input() circular = false;
  @Input() autoplayInterval = 0;
  @Input() showIndicators = true;
  @Input() showNavigators = true;
  @Input() pauseOnHover = true;
  @Input() styleClass = '';

  @ContentChild('item', { read: TemplateRef })
  itemTemplate?: TemplateRef<{ $implicit: unknown; index: number }>;

  @HostBinding('class.doc-carousel-host')
  readonly hostClass = true;

  get effectiveInterval(): number {
    return this.autoplayInterval > 0 ? this.autoplayInterval : 0;
  }

  trackSlide(index: number, slide: unknown): string | number {
    if (slide && typeof slide === 'object') {
      const record = slide as Record<string, unknown>;
      if (record['src']) {
        return String(record['src']);
      }
      if (record['id'] != null) {
        return String(record['id']);
      }
    }

    return index;
  }
}
